export default __webpack_public_path__ + "static/media/point.98ba22f2.jpg";